
import viewRelateFlow from '@/components/browse/view-relate-flow';
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Popup from 'vux/src/components/popup/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'

export default {
name: "virtual-material-management-view",
components: {viewRelateFlow, Grid, GridItem, Popup,dateFormat},
props: ['component'],
data() {
return {
plantPagination:[],
matUnitPagination:[],
techMngPagination:[],
prices:[],
headerTitle: "虚拟物料详情",
isSupplier: false,
orderNo:null,
isDownload: true,
title: null,
isSign: true,
signFileList: [],
signVisible: false,
signObj: {},
baseDto: {flowState: 'send'},
list: [],
index: 1,
show: false,
showList: [],
moreListBol: false,
isInner: false,
en: 0,
flowState: '',
bbsItem: {
bbsImageAttach: {
attachFile: []
}
},
TGvisible:false,
paymentDateDisabled:true,
showInvoiceDetails:false,
soaBillIdex:0
}
},
methods: {
changeSoaDt(data) {
if (data.show) {
this.$set(data, 'show', false);
return;
}
this.$set(data, 'show', true);
},
backLastPage() {
if (this.$store.state.device === 'wap') {
if (this.singleWorkflow) {
this.$router.replace('/');
} else {
this.$router.go(-1);
}
} else {
document.location = "http://action:10002/?";
}
},
switchTabItem(e, info) {
e['list'] = info;
this.$forceUpdate();
},
itemTab(index) {
this.index = index;
if (index === 'flow') {
this.$emit('changeFlowInfo', true);
} else {
this.$emit('changeFlowInfo', false);
}
},
getBaseDto() {
this.$loadingShow();
this.$get('/api/material/' + this.dataId).then((data) => {
this.baseDto = data;
console.log(data)
this.baseDto.dataSource =
this.baseDto.dataFrom == '手工新建'
? '手工新建'
: '从ERP同步';
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
this.$get('api/mat-price/findAllByMatId/' + this.dataId).then((res) => {
this.prices = res;
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
this.$search('api/mat-unit', {},{'material.id': this.dataId}).then((res) => {
this.matUnitPagination = res.pageData.data
console.log(res)
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
this.$search('api/mat-plant', {},{'material.id': this.dataId}).then((res) => {
this.plantPagination = res.pageData.data
console.log(res)
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
this.$search('api/material-document', {},{'material.id': this.dataId}).then((res) => {
this.techMngPagination =res.pageData.data
console.log(res)
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},
showMore() {
this.show = true;
},
getMore() {
if (!this.baseDto.soaDtList) {
return;
}
let showLength = this.showList.length;
let moreLength = this.showList.length + 20;
if (this.baseDto.soaDtList.length > moreLength) {
for (let i = showLength; i < moreLength; i++) {
this.$set(this.baseDto.soaDtList[i], 'show', true);
this.showList.push(this.baseDto.soaDtList[i]);
}
} else {
for (let i = showLength; i < this.baseDto.soaDtList.length; i++) {
if (this.baseDto.soaDtList.length > 20) {
this.$set(this.baseDto.soaDtList[i], 'show', true);
}
this.showList.push(this.baseDto.soaDtList[i]);
}
}
if (this.showList.length >= this.baseDto.soaDtList.length) {
this.moreListBol = false;
} else {
this.moreListBol = true;
}
},
},
mounted() {
this.dataId= this.$route.params.id
if (this.dataId) {
this.getBaseDto()
}
this.isInner = this.$store.state.userType == 1;
if (this.$route.query.orderNo) {
this.orderNo = this.$route.query.orderNo;
}
},
watch: {
dataId() {
if (this.dataId) {
this.getBaseDto()
}
if (this.$route.query.orderNo) {
this.orderNo = this.$route.query.orderNo;
}
}
}
}



// WEBPACK FOOTER //
// ./src/page/virtual-material-management/virtual-material-management-view.vue